(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[name="checkout"]');
    if (!button) return;
    const form = button.closest('[data-cart-form]');
    if (!form) return;
    const fields = form.querySelectorAll('.cart-delivery [required]');
    let firstInvalid = null;
    fields.forEach((field) => {
      const empty = !field.value.trim();
      field.classList.toggle('is-invalid', empty);
      if (empty && !firstInvalid) firstInvalid = field;
    });
    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const nav = document.querySelector('[data-nav]');
    const openBtn = document.querySelector('[data-nav-open]');

    const setOpen = (open) => {
      if (!nav || !openBtn) return;
      nav.hidden = !open;
      openBtn.setAttribute('aria-expanded', String(open));
      document.documentElement.classList.toggle('no-scroll', open);
      if (open) nav.querySelector('[data-nav-close]:not(.mobile-nav__overlay)')?.focus();
    };

    openBtn?.addEventListener('click', () => setOpen(true));
    nav?.querySelectorAll('[data-nav-close]').forEach((el) => el.addEventListener('click', () => setOpen(false)));
    nav?.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav && !nav.hidden) setOpen(false);
    });

    // Rotate announcement items on small screens.
    const items = document.querySelectorAll('.announcement__item');
    if (items.length) {
      let i = 0;
      items[0].classList.add('is-active');
      if (items.length > 1) {
        setInterval(() => {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, 3500);
      }
    }

    // Reveal-on-scroll for elements with .reveal (every page).
    const reveal = () => {
      const els = document.querySelectorAll('.reveal:not(.is-visible)');
      if (!('IntersectionObserver' in window)) {
        els.forEach((el) => el.classList.add('is-visible'));
        return;
      }
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
      els.forEach((el) => io.observe(el));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }
    document.addEventListener('shopify:section:load', reveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class HeroSlider {
      constructor(root) {
        this.root = root;
        this.slides = [...root.querySelectorAll('[data-slide]')];
        this.dots = [...root.querySelectorAll('[data-dot]')];
        this.toggleBtn = root.querySelector('[data-toggle]');
        this.index = 0;
        this.seconds = Math.max(3, parseInt(root.dataset.seconds, 10) || 6);
        this.autoplay = root.dataset.autoplay === 'true';
        this.hold = false;
        this.userPaused = false;
        this.hoverPaused = false;
        this.timer = null;
        this.touchX = null;
        this.touchY = null;
        this.abort = new AbortController();

        if (this.slides.length < 2) return;
        this.bind();
        this.show(0);
        // Warm up the next video once the page has finished loading.
        window.addEventListener('load', () => this.warm(1), { once: true });
      }

      get running() {
        return this.autoplay && !this.userPaused && !this.hoverPaused && !this.hold && !document.hidden;
      }

      bind() {
        const opts = { signal: this.abort.signal };
        const r = this.root;
        r.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1, true), opts);
        r.querySelector('[data-next]')?.addEventListener('click', () => this.go(1, true), opts);
        this.dots.forEach((d) =>
          d.addEventListener('click', () => this.show(parseInt(d.dataset.dot, 10), true), opts)
        );
        this.toggleBtn?.addEventListener('click', () => this.setUserPaused(!this.userPaused), opts);

        // Pause only for a real mouse hover or keyboard focus, never for touch taps.
        r.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.setHover(true); }, opts);
        r.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') this.setHover(false); }, opts);
        r.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.setHover(true); }, opts);
        r.addEventListener('focusout', () => this.setHover(false), opts);
        document.addEventListener('visibilitychange', () => this.refresh(), opts);

        r.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowLeft') this.go(-1, true);
            if (e.key === 'ArrowRight') this.go(1, true);
          },
          opts
        );

        r.addEventListener(
          'touchstart',
          (e) => {
            this.touchX = e.touches[0].clientX;
            this.touchY = e.touches[0].clientY;
          },
          { passive: true, signal: this.abort.signal }
        );
        r.addEventListener(
          'touchend',
          (e) => {
            if (this.touchX === null) return;
            const dx = e.changedTouches[0].clientX - this.touchX;
            const dy = e.changedTouches[0].clientY - this.touchY;
            this.touchX = null;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(dx < 0 ? 1 : -1, true);
          },
          { passive: true, signal: this.abort.signal }
        );

        this.slides.forEach((s) => {
          const v = s.querySelector('video');
          v?.addEventListener('ended', () => {
            if (this.slides[this.index] === s && this.running) this.go(1);
          }, opts);
        });
      }

      video(i) {
        return this.slides[i]?.querySelector('video') || null;
      }

      warm(i) {
        const v = this.video((i + this.slides.length) % this.slides.length);
        if (v && v.preload === 'none') v.preload = 'auto';
      }

      go(step, manual) {
        this.show((this.index + step + this.slides.length) % this.slides.length, manual);
      }

      show(i, manual) {
        this.slides.forEach((s, n) => {
          const active = n === i;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.inert = !active;
          if (!active) {
            const v = s.querySelector('video');
            if (v && !v.paused) v.pause();
          }
        });
        this.dots.forEach((d, n) => {
          if (n === i) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        this.index = i;
        const v = this.video(i);
        if (v) {
          v.muted = true;
          v.currentTime = 0;
          if (this.autoplay && !this.userPaused) v.play().catch(() => {});
        }
        this.warm(i + 1);
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.running) return;
        const v = this.video(this.index);
        let wait = this.seconds;
        if (v) {
          const dur = isFinite(v.duration) && v.duration > 0 ? v.duration : 10;
          wait = Math.max(this.seconds, dur - (v.currentTime || 0) + 1.5);
        }
        this.timer = setTimeout(() => this.go(1), wait * 1000);
      }

      refresh() {
        const v = this.video(this.index);
        if (this.running) {
          if (v && v.paused) v.play().catch(() => {});
          this.schedule();
        } else {
          clearTimeout(this.timer);
          if (v && !v.paused) v.pause();
        }
      }

      setHover(state) {
        this.hoverPaused = state;
        this.refresh();
      }

      setUserPaused(state) {
        this.userPaused = state;
        this.root.classList.toggle('is-paused', state);
        if (this.toggleBtn) {
          this.toggleBtn.setAttribute('aria-pressed', String(state));
          this.toggleBtn.setAttribute('aria-label', state ? 'Play slideshow' : 'Pause slideshow');
        }
        this.refresh();
      }

      stop() {
        this.autoplay = false;
        clearTimeout(this.timer);
        this.slides.forEach((s) => s.querySelector('video')?.pause());
      }

      destroy() {
        this.stop();
        this.abort.abort();
      }
    }

    const instances = new WeakMap();

    const init = (root) => {
      if (!root || instances.has(root)) return;
      instances.set(root, new HeroSlider(root));
    };

    const initAll = () => document.querySelectorAll('[data-hero-slider]').forEach(init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    // Theme editor support: jump to the slide being edited and keep it still.
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll?.('[data-hero-slider]').forEach(init);
    });
    document.addEventListener('shopify:section:unload', (e) => {
      e.target.querySelectorAll?.('[data-hero-slider]').forEach((root) => {
        instances.get(root)?.destroy();
        instances.delete(root);
      });
    });
    document.addEventListener('shopify:block:select', (e) => {
      const root = e.target.closest?.('[data-hero-slider]');
      const inst = root && instances.get(root);
      if (!inst) return;
      const i = inst.slides.indexOf(e.target);
      if (i > -1) {
        inst.hold = true;
        inst.show(i, true);
      }
    });
    const release = (e) => {
      const root = e.target.closest?.('[data-hero-slider]') || e.target.querySelector?.('[data-hero-slider]');
      const inst = root && instances.get(root);
      if (inst) {
        inst.hold = false;
        inst.refresh();
      }
    };
    document.addEventListener('shopify:block:deselect', release);
    document.addEventListener('shopify:section:deselect', release);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;

    // Gallery thumbnails
    const slides = section.querySelectorAll('[data-slide]');
    const thumbs = section.querySelectorAll('[data-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const i = thumb.dataset.thumb;
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.slide === i));
        thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });

    // Quantity stepper
    const qty = section.querySelector('[data-qty] input');
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      qty.value = Math.min(10, (parseInt(qty.value, 10) || 1) + 1);
    });

    // Variant select updates price and button state
    const select = section.querySelector('[data-variant-select]');
    const priceEl = section.querySelector('[data-price]');
    const atc = section.querySelector('[data-atc]');
    const atcLabel = section.querySelector('[data-atc-label]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      const available = opt.dataset.available === 'true';
      let html = `<span class="price">${opt.dataset.price}</span>`;
      if (opt.dataset.compare) html += `<s>${opt.dataset.compare}</s>`;
      priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.innerHTML = opt.dataset.price;
      atc.disabled = !available;
      atcLabel.textContent = available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      history.replaceState({}, '', url);
    });

    // Sticky add-to-cart once the main button scrolls away
    const sticky = document.querySelector('[data-sticky-atc]');
    const stickyBtn = document.querySelector('[data-sticky-btn]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', () => atc.click());
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
